var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ea022d1e51a652b1f3a378ff80da2f9bcc0e6838"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["productreviews-evaluatepage@trustpilot"]={id:"ea022d1e51a652b1f3a378ff80da2f9bcc0e6838"};
      